module.exports = __webpack_public_path__ + "static/assets/c6b0ffccda25e07c55a4bafdc4464946.png";